import { apiClient } from './axios';

import type { CallComment } from '@repo/shared-types';

export interface PaginatedComments {
  data: CallComment[];
  meta: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export const commentsApi = {
  getComments: async (callId: string, page = 1, limit = 20): Promise<PaginatedComments> => {
    const response = await apiClient.get<PaginatedComments>(`/calls/${callId}/comments`, {
      params: { page, limit },
    });
    return response.data;
  },

  addComment: async (callId: string, content: string): Promise<CallComment> => {
    const response = await apiClient.post<CallComment>(`/calls/${callId}/comments`, { content });
    return response.data;
  },

  deleteComment: async (commentId: string): Promise<void> => {
    await apiClient.delete(`/calls/comments/${commentId}`);
  },
};
